angular.module('passwords')
.controller('PasswordsController', ['$scope', '$state', '$stateParams', 'Notification', 'Password', 'Auth', 'AccountSetupActions', 'EmailSuppressionWarning', 'TrialExpiryWarning',
    function ($scope, $state, $stateParams, Notification, Password, Auth, AccountSetupActions, EmailSuppressionWarning, TrialExpiryWarning) {
        // DCL-623: only a 422 carries Devise's {errors: {attribute: [messages]}}.
        // A 5xx answers {status, error} from ErrorsController and a network or
        // proxy failure has no body at all, so every reader of failure.data has
        // to fall back to a generic message rather than throw.
        var GENERIC_FAILURE = 'password.request.failed';

        function humanize(attribute) {
            var words = attribute.replace(/_/g, ' ');
            return words.charAt(0).toUpperCase() + words.slice(1);
        }

        function changeFailureMessage(failure) {
            var errors = failure && failure.data && failure.data.errors;
            if (!errors || typeof errors !== 'object' || Array.isArray(errors)) {
                return GENERIC_FAILURE;
            }
            if (errors.reset_password_token) {
                return 'reset_password_token.invalid';
            }
            // e.g. "Password is too short (minimum is 8 characters)", or a legacy
            // account failing a User validation such as "First name can't be blank".
            var sentences = Object.keys(errors).filter(function (attribute) {
                return [].concat(errors[attribute]).length;
            }).map(function (attribute) {
                return humanize(attribute) + ' ' + [].concat(errors[attribute]).join(', ');
            });
            return sentences.length ? sentences.join('. ') : GENERIC_FAILURE;
        }

        $scope.requestPasswordReset = function (user) {
            Password.reset({'user': user},
                function (result) {
                    Notification.success('Success! Please check your email for password reset instructions.');
                },
                function (failure) {
                    Notification.error((failure && failure.data && failure.data.error) || GENERIC_FAILURE);
                })
        };
        $scope.initial = true;
        $scope.success = false;
        $scope.changePassword = function (model) {
            model.reset_password_token = $stateParams.reset_password_token;
            Password.change({'user': model, 'format': 'json'},
                function (success_result) {
                    // DCL-611: a successful reset rotates the authentication token,
                    // so any login this browser still holds is dead. Clear it the
                    // way logout does; otherwise LoginController sees the stale
                    // auth_context, bounces to /history with no user loaded, and
                    // the first API call 401s back to sign-in.
                    Auth.remove();
                    Auth.current_user = null;
                    AccountSetupActions.reset();
                    EmailSuppressionWarning.reset();
                    TrialExpiryWarning.reset();
                    Notification.dismiss();
                    $state.go('signIn');
                },
                function (failure) {
                    Notification.error(changeFailureMessage(failure));
                });
        };
    }]);
